import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=09fd57f9&scoped=true&"
import script from "./DoctorList.vue?vue&type=script&lang=js&"
export * from "./DoctorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd57f9",
  null
  
)

export default component.exports